import React from 'react';
import img from '../Images/ucla-library.jpg';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import StaffSection from '../components/StaffSection';

const Staff = () => {
  return (
    <>
      <Navbar />
      <Hero 
      cName='hero-mid'
      img={img}
      title='Staff'
      text='Meet our wonderful staff!'/>
      <StaffSection />
      <Footer />
    </>
  );
}

export default Staff;
